// extracted by mini-css-extract-plugin
export default {"textBlock":"Technologies_textBlock__T30Xc","topText":"Technologies_topText__K1Bz8","icon":"Technologies_icon__1Al1q","bottomText":"Technologies_bottomText__If3tX"};